<template>
  <WizardEventDispatcher :event="'mouseover'" :target="'window-content'">
    <div class="window" v-bind:class="{ 'window--minified': !windowOpen }">
      <div class="window__header">
        <div class="window__title" v-on:click="toggle()">
          <h2>
            <slot name="header"></slot>
          </h2>
        </div>
        <div class="window__buttons">
          <button v-on:click="toggle()">
            <span v-if="windowOpen">&#8211;</span>
            <span class="icon--small" v-else>&#8593;</span>
          </button>
          <WizardEventDispatcher
            :event="'click'"
            :target="'button-window-close'"
          >
            <button v-on:click="close()" :id="type">&times;</button>
          </WizardEventDispatcher>
        </div>
      </div>

      <div class="window__content">
        <slot name="content"></slot>
      </div>
    </div>
  </WizardEventDispatcher>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      windowOpen: true
    };
  },
  computed: {
    ...mapState(['general', 'threads', 'gmaps']),
    ...mapActions([
      'general/setNewCommentPhase',
      'general/setLayoutOption',
      'general/setNewPinPhase',
      'general/destroyPinPolyline'
    ])
  },
  methods: {
    toggle() {
      if (this.windowOpen) {
        this.windowOpen = false;
      } else {
        this.windowOpen = true;
      }
    },
    close() {
      if (this.type == 'newComment') {
        this.$store.dispatch('general/setNewCommentPhase', null);
      }
      if (this.type == 'newPin') {
        this.$store.dispatch('general/setNewPinPhase', null);
      }
      if (this.type == 'editPin') {
        this.$store.dispatch('general/clearEditPinId');
        this.$store.dispatch('general/restorePreviousLines');
      }
      this.$store.dispatch('general/setLayoutOption', [this.type, false]);
    }
  },
  components: {
    WizardEventDispatcher
  }
};
</script>

<style scoped>
.window {
  position: relative;
  bottom: 0;
  margin-left: 2%;
  width: 96%;
  max-width: 25rem;
  min-height: 2.5rem;
  /*max-height: 80vh;*/
  max-height: 90%;
  height: auto;
  z-index: 9999;
  background-color: #fff;
  /*padding: 2.3rem 0 0 0;*/
  display: flex;
  flex-direction: column;

  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.18);
  border-radius: 0.2rem;
  white-space: initial;
  overflow: hidden;
  pointer-events: all;
}

.window__header {
  display: flex;
  flex-direction: row;
  width: 100%;
  /*background-color: #3a87df;
  position: absolute;
  top: 0;
  left: 0;*/
  padding: 0.25rem 0.5rem;
  height: 2.4rem;
}

.window__title {
  cursor: pointer;
  flex: 1;
}
/*
.window__buttons {
  position: absolute;
  right: 1rem;
  top: 0;
  width: 4rem;
  height: 3.8rem;
}*/
.window__buttons button {
  -moz-appearance: none;
  -webkit-appearance: none;
  color: #1a1919;
  font-size: 2.5rem;
  cursor: pointer;
  box-shadow: none;
  border: none;
  background-color: transparent;

  line-height: 0.5em;
}

.window__buttons .icon--small {
  font-size: 1.8rem;
}

.window__header h2 {
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
}

.window--minified .window__content {
  display: none;
}

.window__content {
  height: 100%;
  overflow-y: auto;
  padding: 0.5rem;
  flex: 1;
  margin-top: 1rem;
}
</style>
